<div class="multi-select-dropdown">
  <!-- Dropdown toggle: shows selected items or placeholder -->
  <div
    class="form-control form-select dropdown-toggle-borders"
    [class.show]="dropdownOpen"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="onToggle()"
    tabindex="0"
  >
    <span *ngIf="selectedValues.length === 0">{{ placeholder }}</span>
    <span *ngIf="selectedValues.length > 0">{{
      selectedValues.join(", ")
    }}</span>
    <!-- Add Bootstrap Icons chevron-down -->
    <i class="bi bi-chevron-down"></i>
  </div>

  <!-- Dropdown menu: list of options with checkboxes, rendered in a CDK overlay -->
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="dropdownOpen"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayWidth]="menuWidth"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    (backdropClick)="closeDropdown()"
    (detach)="closeDropdown()"
  >
    <div class="dropdown-menu show">
      <div
        *ngFor="let option of options; trackBy: trackByValue"
        class="dropdown-item"
        (click)="toggleOption(option, $event)"
      >
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            [value]="option.value"
            [checked]="selectedValues.indexOf(option.value) !== -1"
            (click)="onCheckboxClick($event)"
            (change)="onCheckboxChange($event, option)"
          />
          <label class="form-check-label">
            {{ option.label }}
          </label>
        </div>
      </div>
    </div>
  </ng-template>
</div>
